import { render, staticRenderFns } from "./AgreementText.vue?vue&type=template&id=5145821c&"
import script from "./AgreementText.vue?vue&type=script&lang=js&"
export * from "./AgreementText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports